import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { NotificationItem, useOpenNotification } from "@/components/NotificationBell";
import { Button } from "@/components/ui/button";
import { PageLoader } from "@/components/layout/RequireAuth";
import { EmptyState } from "@/pages/CategoryPage";

export default function Notifications() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/notifications", { params: { limit: 200 } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const openN = useOpenNotification();
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="container-page max-w-3xl py-10 lg:py-14" data-testid="notifications-page">
      <div className="flex items-end justify-between gap-4">
        <h1 className="text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Notifikasi</h1>
        <Button variant="outline" className="rounded-xl" onClick={readAll} data-testid="notifications-read-all">Tandai semua dibaca</Button>
      </div>
      <div className="mt-8">
        {items === null ? <PageLoader /> : items.length === 0 ? <EmptyState testId="notifications-empty" title="Belum ada notifikasi" /> : (
          <div className="card-soft divide-y divide-stone-100 overflow-hidden">
            {items.map((n) => <NotificationItem key={n.notification_id} n={n} onOpen={openN} />)}
          </div>
        )}
      </div>
    </div>
  );
}
